export const fonts = {
  font_sizes: {
    header: {
      sm: 20,
      sm1: 20,
      md: 24,
      md1: 24,
      lg: 32,
      xl: 40,
      xl1: 40,
      h1: 36,
      h2: 32,
      h3: 24,
      h4: 20,
      promo2: 44
    },
    par: {
      sm: 12,
      md: 14,
      lg: 17,
      xl: 20,
      p1: 24,
      p2: 20,
      p3: 17,
      p4: 14,
      c1: 12,
      c2: 10
    }
  },
  font_family: '"MTS Sans", "Arial", "Helvetica", sans-serif',
  font_family_wide: '"MTS Wide", sans-serif',
  font_family_comp: '"MTS Compact", sans-serif',
  font_family_text: '"MTS Text", sans-serif',
  font_weights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
  },
  line_heights: {
    header: {
      sm: 24,
      sm1: 28,
      md: 28,
      md1: 32,
      lg: 36,
      xl: 44,
      xl1: 48,
      h1: 40,
      h2: 36,
      h3: 28,
      h4: 24,
      promo2: 44
    },
    par: {
      sm: 16,
      md: 20,
      lg: 24,
      xl: 24,
      p1: 32,
      p2: 28,
      p3: 24,
      p4: 20,
      c1: 16,
      c2: 12
    }
  },
  bottom_margins: {
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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